let defaultUserPermissions = {
    CAN_VIEW_ADMIN: false,
    CAN_UPLOAD_IMAGES: false,
};

module.exports = defaultUserPermissions;
